module.exports = __webpack_public_path__ + "img/screen2.57626e10.png";